import { SectionHeaderProps } from 'components/PageSections/components/SectionHeader';
import {
  getMobileAndDesktopFirstImage,
  getMobileAndDesktopFirstVideo,
} from 'components/PageSections/utils';

import { HeroWithExternalVideoProps } from './HeroWithExternalVideo';

export function parseHeroWithExternalVideo(
  section: Queries.ContentfulSection001 | Queries.pdpSectionFragment,
): HeroWithExternalVideoProps {
  const { metadata } = section;
  const { theme } = metadata || {};

  const sectionVideos = getMobileAndDesktopFirstVideo(section?.images ?? null);
  const sectionImages = getMobileAndDesktopFirstImage(section?.images ?? null);

  return {
    title: metadata?.title ?? null,
    titleColor: theme?.primaryColor ?? null,
    titleTag:
      (metadata?.context?.titleTag as SectionHeaderProps['headingLevel']) ??
      'h1',
    eyebrow: section?.eyebrow ?? null,
    eyebrowColor: theme?.secondaryColor ?? null,
    cta: metadata?.ctas ? metadata.ctas[0] : null,
    mobileVideo: sectionVideos?.mobileVideo ?? null,
    desktopVideo: sectionVideos?.desktopVideo ?? null,
    mobileImage:
      sectionImages?.mobileImage?.gatsbyImageData?.images?.fallback?.src ?? '',
    desktopImage:
      sectionImages?.desktopImage?.gatsbyImageData?.images?.fallback?.src ?? '',
    mobileGradientBackground: metadata?.theme?.gradientColor1 ?? null,
    desktopGradientBackground: metadata?.theme?.gradientColor2 ?? null,
    videoBackgroundColor: metadata?.theme?.backgroundColor ?? null,
  };
}
